<form id="catalog-form" *ngIf="form && catalogTypeGiftFields" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 *ngIf="catalogTypeGiftId" class="step-title">{{ 'common.edit' | translate }} {{ 'catalog.giftType' | translate }}</h1>
        <h1 *ngIf="!catalogTypeGiftId" class="step-title">{{ 'common.add' | translate }} {{ 'catalog.giftType' | translate }}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/promotion/catalog-gift-type" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">
        <!-- Codice -->
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !catalogTypeGiftFields.code.nullable}">{{ catalogTypeGiftFields.code.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="code"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogTypeGiftFields.code"></app-validation-msg>
        </div>
        <!-- Descrizione -->
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !catalogTypeGiftFields.description.nullable}">{{ catalogTypeGiftFields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogTypeGiftFields.description"></app-validation-msg>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <!-- Template Prenotazione -->
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !catalogTypeGiftFields.template_reserv.nullable}">{{ catalogTypeGiftFields.template_reserv.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="template_reserv"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogTypeGiftFields.template_reserv"></app-validation-msg>
        </div>
        <!-- Template Ritiro -->
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !catalogTypeGiftFields.template_pickup.nullable}">{{ catalogTypeGiftFields.template_pickup.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="template_pickup"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogTypeGiftFields.template_pickup"></app-validation-msg>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <!--Template Annulla -->
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !catalogTypeGiftFields.template_delete.nullable}">{{ catalogTypeGiftFields.template_delete.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="template_delete"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogTypeGiftFields.template_delete"></app-validation-msg>
        </div>
       </div>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog-gift-type/catalog-gift-type-detail/catalog-gift-type-detail.component.html